import './PracticesInfo.scss'

import { useState } from 'react'
import { Button, Col, Modal, Row } from 'react-bootstrap'
import { useMediaQuery } from 'react-responsive'
import Drawer from 'react-bottom-drawer'

import PracticesCarousel from 'components/welcome/PracticesCarousel'

import { ReactComponent as IconPractices } from '../../../assets/images/icons/icon-practices.svg'

/**
 * Simple Practices Info component. Used during onboarding and on the Activities landing page
 */
export default function PracticesInfo() {
  const isLargeScreen = useMediaQuery({ minWidth: 768 })
  const [isDrawerVisible, setIsDrawerVisible] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)

  return (
    <>
      <Row className='not-sure-banner'>
        <Col xs={7}>
          <h4 className='my-0'>Not sure?</h4>
          <p className='muted'>
            <small>See what we suggest</small>
          </p>
        </Col>
        <Col xs={5} className='p-0'>
          <Button
            className='btn btn-light-green w-100 border-0'
            onClick={_ =>
              isLargeScreen ? setIsModalVisible(true) : setIsDrawerVisible(true)
            }
          >
            <span className='icon green'>
              <IconPractices />
            </span>
            <small>Practices</small>
          </Button>
        </Col>
      </Row>

      <Drawer
        duration={250}
        hideScrollbars={true}
        onClose={_ => setIsDrawerVisible(false)}
        isVisible={isDrawerVisible}
        className='modal-practices-preview-drawer'
      >
        <PracticesCarousel />
      </Drawer>
      <Modal
        show={isModalVisible}
        onHide={_ => setIsModalVisible(false)}
        dialogClassName='modal-practices-preview mobile-hidden'
      >
        <Modal.Header closeButton>
          <Modal.Title>Practices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PracticesCarousel />
        </Modal.Body>
      </Modal>
    </>
  )
}
